import API from './axiosConfig'

export default {
  agreements: {
    getAll: params =>
      API.get('/agreements', {
        params: { userName: 'string', ...params }
      }),
    getOne: (id, params = {}) => API.get(`/agreements/${id}`, {params: params}),
    create: data => API.post('/agreements/', data),
    edit: data => API.put(`/agreements/${data.agreementId}`, data)
  },
  references: {
    getAll: supplier => API.get('/references/list',{
      params: {...supplier}
    }),
    retrieveStocks: (productIds, storeIds) => API.get('/references/stock', {
      params: {
        productIds: productIds.join(','),
        storeIds: storeIds.join(',')
      }
    })
  },
  domains: {
    getAgreementState: () => {
      return API.get('/domains/AgreementStateCode');
    },
    getPurposeState: (params) => {
      return API.get('/domains/ProposalStateCode', {params: params});
    }
  },
  stores: {
    getAll: () => API.get('/stores')
  },
  suppliers: {
    getAll: () => API.get('/suppliers'),
    search: value => API.get(`/suppliers/list?search=${encodeURIComponent(value)}`)
  },
  purposes: {
    getAll: params => API.get('/views/proposals', {
      params: {...params}
    }),
    getOne: id => API.get(`/views/proposals/${id}`),
    updateConnections: connections => API.put(`/proposals/connections`, {data: connections}),
    edit: data => API.put(`/proposals/${data.id}`, data)
  },
  auth: {
    getToken: (token, type) => API.get(`/authentication/generate`, {params: {token: token, type: type}, showMessage: false}),
    decode: () => API.get(`/authentication/decode`, {showMessage: false}),
    getOAuthInfo: () => API.get(`/authentication/oauth-information`, {showMessage: false}),
    exchangeAuthorizationCodeForToken: (code) => API.post(`/authentication/exchange-code?code=${code}`, {}, {showMessage: false})
  }
}



// WEBPACK FOOTER //
// ./src/common/api.js